import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { randuBlogService } from "../services/api";

const BlogRanduCategoriesPage = () => {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");

  const load = async () => {
    const res = await randuBlogService.listCustomCategories();
    if (res.success) setItems(res.items || []);
  };

  useEffect(() => {
    load();
  }, []);

  const add = async () => {
    if (!name.trim()) return;
    await randuBlogService.createCustomCategory({ name, slug: slug || undefined, sort_order: 0 });
    setName("");
    setSlug("");
    load();
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Randu.app Blog — Kategoriler" />
      <div className="card mb-3">
        <div className="card-body row g-2 align-items-end">
          <div className="col-md-4">
            <label className="form-label">Kategori adı</label>
            <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Slug (opsiyonel)</label>
            <input className="form-control" value={slug} onChange={(e) => setSlug(e.target.value)} />
          </div>
          <div className="col-md-4">
            <button type="button" className="btn btn-primary" onClick={add}>
              Ekle
            </button>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Slug</th>
                <th>Ad</th>
                <th>Aktif</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id}>
                  <td>{c.id}</td>
                  <td>{c.slug}</td>
                  <td>{c.name}</td>
                  <td>{c.is_active ? "Evet" : "Hayır"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </MasterLayout>
  );
};

export default BlogRanduCategoriesPage;
